"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _AuthStore = require("../store/AuthStore");

var _default = (0, _AuthStore.defineAuthStore)({
  getter: function getter(state, field) {
    return field ? state[field] : state;
  },
  initialState: {},
  name: 'UserStore',
  onAuthLoad: function onAuthLoad(auth) {
    return auth.user;
  }
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;